import { render } from "./TagSearchSuggest.vue?vue&type=template&id=7c6db920&scoped=true"
import script from "./TagSearchSuggest.vue?vue&type=script&lang=js"
export * from "./TagSearchSuggest.vue?vue&type=script&lang=js"

import "./TagSearchSuggest.vue?vue&type=style&index=0&id=7c6db920&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1700309314/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c6db920"]])

export default __exports__